<script>
import { iIcon } from '@inscribe/signal';

export default {
  components: { iIcon },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'medium-file-alert-1',
    },
  },
  data() {
    return { hovering: false };
  },
  computed: {},
};
</script>

<template>
  <div
    class="empty-state d-flex align-items-center i-radius-xl i-px-9 i-py-8 i-gap-8"
  >
    <i-icon :symbol="icon" :size="16"></i-icon>
    <div class="content d-flex flex-column align-items-start i-gap-1">
      <div class="title i-text-button-3 i-text-neutral-120">{{ title }}</div>
      <div v-if="subtitle" class="subtitle i-text-body-3 i-text-neutral-110">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.empty-state {
  background: $light-neutral-20;
}
</style>
